import { Box, Button, Stack, Typography } from "@mui/material";
import FAQComponent from "../../Components/faq/FAQ";

const userGuideDocument = require("../../assets/documents/user-guide.pdf");

const DisclaimerAndGuide = () => {
  return (
    <Stack maxWidth="720px" py="2.625rem" gap="2rem">
      <Stack gap={3}>
        <Typography
          variant="display4"
          lineHeight={{
            xl: "2.625rem",
            lg: "2.5rem",
          }}
          textAlign="left"
        >
          User Guide
        </Typography>
        <Typography variant="h2" textAlign="left">
          FAQ
        </Typography>
        <Typography variant="subtitle1" textAlign="left" color="secondary">
          We have collected frequently asked questions, that might help you in
          getting your question answered. You can also read the full user guide
          below.
        </Typography>
      </Stack>
      <Stack>
        <Box sx={{ marginTop: "25px" }}>
          <FAQComponent />
        </Box>
        <Box sx={{ paddingY: "40px" }}>
          <Typography variant="h5" fontSize="24px">
            Documentation
          </Typography>
          <Typography variant="subtitle1" textAlign="left" color="secondary">
            Please see the full user guide here, if you have more questions.
          </Typography>
          <Button
            variant="outlined"
            sx={{
              marginTop: "30px",
              fontSize: "14px",
              borderColor: "#2D3648",
              textTransform: "none",
              color: "#2D3648",
            }}
            onClick={() => window.open(userGuideDocument, "_blank")}
          >
            Read full user guide
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
};

export default DisclaimerAndGuide;
